import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { Interceptors } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { ActivityService } from './services.gen';
import { AdminOauthClientsService } from './services.gen';
import { AlertsService } from './services.gen';
import { ApiTokensService } from './services.gen';
import { AuthService } from './services.gen';
import { CliService } from './services.gen';
import { ConfigRevisionService } from './services.gen';
import { ConfigRevisionsService } from './services.gen';
import { FeatureFlagsService } from './services.gen';
import { InstallerTokensService } from './services.gen';
import { JobsService } from './services.gen';
import { NodeConfigsService } from './services.gen';
import { NodeCredentialsService } from './services.gen';
import { NodeFeaturesService } from './services.gen';
import { NodeGroupsService } from './services.gen';
import { NodeLifecycleEventsService } from './services.gen';
import { NodeReleasesService } from './services.gen';
import { NodesService } from './services.gen';
import { NotificationsService } from './services.gen';
import { OauthService } from './services.gen';
import { OauthClientsService } from './services.gen';
import { ProvisioningCredentialsService } from './services.gen';
import { ReleasesService } from './services.gen';
import { SubtenantsService } from './services.gen';
import { SystemInfoService } from './services.gen';
import { TagsService } from './services.gen';
import { TelemetryService } from './services.gen';
import { TenantReleasesService } from './services.gen';
import { TenantsService } from './services.gen';
import { UsersService } from './services.gen';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class MgmtPlaneClient {

	public readonly activity: ActivityService;
	public readonly adminOauthClients: AdminOauthClientsService;
	public readonly alerts: AlertsService;
	public readonly apiTokens: ApiTokensService;
	public readonly auth: AuthService;
	public readonly cli: CliService;
	public readonly configRevision: ConfigRevisionService;
	public readonly configRevisions: ConfigRevisionsService;
	public readonly featureFlags: FeatureFlagsService;
	public readonly installerTokens: InstallerTokensService;
	public readonly jobs: JobsService;
	public readonly nodeConfigs: NodeConfigsService;
	public readonly nodeCredentials: NodeCredentialsService;
	public readonly nodeFeatures: NodeFeaturesService;
	public readonly nodeGroups: NodeGroupsService;
	public readonly nodeLifecycleEvents: NodeLifecycleEventsService;
	public readonly nodeReleases: NodeReleasesService;
	public readonly nodes: NodesService;
	public readonly notifications: NotificationsService;
	public readonly oauth: OauthService;
	public readonly oauthClients: OauthClientsService;
	public readonly provisioningCredentials: ProvisioningCredentialsService;
	public readonly releases: ReleasesService;
	public readonly subtenants: SubtenantsService;
	public readonly systemInfo: SystemInfoService;
	public readonly tags: TagsService;
	public readonly telemetry: TelemetryService;
	public readonly tenantReleases: TenantReleasesService;
	public readonly tenants: TenantsService;
	public readonly users: UsersService;

	public readonly request: BaseHttpRequest;

	constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
		this.request = new HttpRequest({
			BASE: config?.BASE ?? '',
			VERSION: config?.VERSION ?? '1.0.0',
			WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
			CREDENTIALS: config?.CREDENTIALS ?? 'include',
			TOKEN: config?.TOKEN,
			USERNAME: config?.USERNAME,
			PASSWORD: config?.PASSWORD,
			HEADERS: config?.HEADERS,
			ENCODE_PATH: config?.ENCODE_PATH,
			interceptors: {
				request: config?.interceptors?.request ?? new Interceptors(),
				response: config?.interceptors?.response ?? new Interceptors(),
      },
		});

		this.activity = new ActivityService(this.request);
		this.adminOauthClients = new AdminOauthClientsService(this.request);
		this.alerts = new AlertsService(this.request);
		this.apiTokens = new ApiTokensService(this.request);
		this.auth = new AuthService(this.request);
		this.cli = new CliService(this.request);
		this.configRevision = new ConfigRevisionService(this.request);
		this.configRevisions = new ConfigRevisionsService(this.request);
		this.featureFlags = new FeatureFlagsService(this.request);
		this.installerTokens = new InstallerTokensService(this.request);
		this.jobs = new JobsService(this.request);
		this.nodeConfigs = new NodeConfigsService(this.request);
		this.nodeCredentials = new NodeCredentialsService(this.request);
		this.nodeFeatures = new NodeFeaturesService(this.request);
		this.nodeGroups = new NodeGroupsService(this.request);
		this.nodeLifecycleEvents = new NodeLifecycleEventsService(this.request);
		this.nodeReleases = new NodeReleasesService(this.request);
		this.nodes = new NodesService(this.request);
		this.notifications = new NotificationsService(this.request);
		this.oauth = new OauthService(this.request);
		this.oauthClients = new OauthClientsService(this.request);
		this.provisioningCredentials = new ProvisioningCredentialsService(this.request);
		this.releases = new ReleasesService(this.request);
		this.subtenants = new SubtenantsService(this.request);
		this.systemInfo = new SystemInfoService(this.request);
		this.tags = new TagsService(this.request);
		this.telemetry = new TelemetryService(this.request);
		this.tenantReleases = new TenantReleasesService(this.request);
		this.tenants = new TenantsService(this.request);
		this.users = new UsersService(this.request);
	}
}
